import * as types from "../ActionType";

const initState = {
    evaluation: [],
    loadingevaluation: true
}

const EvaluationTypeReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_EVALUATION_TYPE:
            return { ...state, loadingevaluation: true }
        case types.GET_EVALUATION_TYPE:
            return { ...state, evaluation: action.payload, loadingevaluation: false }
        case types.DELETE_EVALUATION_TYPE:
            return { ...state }
        case types.EDIT_EVALUATION_TYPEE:
            return { ...state, loadingevaluation: true }
        default:
            return state;
    }
};

export default EvaluationTypeReducer;
